import { Robot, User } from "@phosphor-icons/react";
import { useEffect, useRef } from "react";

export default function MessageList({ messages, streaming }) {
  const endRef = useRef(null);
  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, streaming]);

  if (messages.length === 0) {
    return (
      <div className="text-zinc-500 text-center mt-20">
        <Robot size={48} weight="duotone" className="mx-auto text-blue-500 mb-3" />
        Ask anything about your career path, skills, interviews, or roadmap.
      </div>
    );
  }

  return (
    <>
      {messages.map((m) => (
        <Bubble key={m.key} role={m.role} content={m.content} />
      ))}
      <div ref={endRef} />
    </>
  );
}

const Bubble = ({ role, content }) => (
  <div className={`flex gap-3 ${role === "user" ? "justify-end" : ""}`}>
    {role === "assistant" && (
      <div className="w-8 h-8 rounded-full bg-blue-600/20 border border-blue-500/40 flex items-center justify-center shrink-0">
        <Robot size={16} className="text-blue-400" />
      </div>
    )}
    <div
      data-testid={`msg-${role}`}
      className={`max-w-[80%] rounded-2xl px-4 py-3 ${
        role === "user" ? "bg-blue-600 text-white" : "bg-[#0F0F12] border border-white/10 text-zinc-100"
      }`}
    >
      <div className="whitespace-pre-wrap text-sm leading-relaxed">
        {content || <span className="text-zinc-500">…</span>}
      </div>
    </div>
    {role === "user" && (
      <div className="w-8 h-8 rounded-full bg-white/5 border border-white/10 flex items-center justify-center shrink-0">
        <User size={16} />
      </div>
    )}
  </div>
);
